import "./Footer.css"
const Footer = () => {
    return ( 
        <div className="footer_component">
               <p className="footer_context">Developed by LLC BPMS | <a  target="_blank" href="https://bpms.ge/">bpms.ge</a></p>
        </div>
     );
}
 
export default Footer;